/**
 * manga-consultation-reserve.js 
 */
(function () {
  'use strict';

  const root            = document.getElementById('manga-consultation-reserve');
  const instructorBtns  = document.getElementById('instructor-buttons');
  const loadingEl       = document.getElementById('booking-loading');
  const stepCalendar    = document.getElementById('step-calendar');
  const stepSlots       = document.getElementById('step-slots');
  const stepConfirm     = document.getElementById('step-confirm');
  const calLabels       = document.getElementById('cal-labels');
  const calDays         = document.getElementById('cal-days');
  const calMonthLabel   = document.getElementById('cal-month-label');
  const calPrevBtn      = document.getElementById('cal-prev');
  const calNextBtn      = document.getElementById('cal-next');
  const slotList        = document.getElementById('slot-list');
  const bookingSummary  = document.getElementById('booking-summary');
  const addToCartBtn    = document.getElementById('btn-add-to-cart');
  const errorEl         = document.getElementById('booking-error');
  const errorMsgEl      = document.getElementById('booking-error-message');

  const shopId = root.dataset.shopId;
  let instructors = [];
  try {
    var raw = (root.dataset.instructors || '[]')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
    instructors = JSON.parse(raw);
  } catch (e) {
    showError('講師データの読み込みに失敗しました。セクション設定のJSONを確認してください。');
    return;
  }

  const state = {
    selectedDuration:   30,
    selectedInstructor: null,
    isAny:              false,
    anyInstances:       [],
    anyAvailabilities:  {},
    sesamiInstance:     null,
    selectedDay:        null,
    selectedSlot:       null,
    selectedVariantId:  null,
    monthOffset:        0,   // 0:当月 1:翌月（最大1まで）
  };

  function init() {
    buildInstructorButtons();
    bindDurationButtons();
    bindCalendarNav();
    addToCartBtn.addEventListener('click', handleAddToCart);
  }

  // ── 選択中の枠に対応していて、かつ価格が0より大きい講師のみ返す ──
  // price が未設定（undefined/null）の場合は表示対象とする
  // price が明示的に 0 に設定されている場合のみ非表示にする
  function getAvailableInstructors() {
    return instructors.filter(function (instr) {
      if (state.selectedDuration === 30) {
        if (!instr.variant30Id) return false;
        return instr.price30 == null || instr.price30 > 0;
      }
      if (state.selectedDuration === 60) {
        if (!instr.variant60Id) return false;
        return instr.price60 == null || instr.price60 > 0;
      }
      return false;
    });
  }

  // ── 講師ボタンの動的生成（1カラム・カード選択・説明折りたたみ）──
  function buildInstructorButtons() {
    const anyBtn = instructorBtns.querySelector('[data-instructor-id="any"]');
    if (anyBtn) {
      anyBtn.addEventListener('click', function () { onSelectAny(); });
    }

    // 既存の講師カードを全て削除（再描画のため）
    instructorBtns.querySelectorAll('.manga-consultation-reserve__instructor-item').forEach(function (el) {
      el.remove();
    });

    // 選択中の枠に対応している講師のみ表示する
    getAvailableInstructors().forEach(function (instructor) {
      const item = document.createElement('div');
      item.className = 'manga-consultation-reserve__instructor-item';
      item.dataset.instructorId = instructor.id;

      // 画像HTML
      const imgHtml = instructor.imageUrl
        ? '<img src="' + instructor.imageUrl + '" alt="' + instructor.name + '" class="manga-consultation-reserve__instructor-img" onerror="this.style.display=\'none\';this.nextElementSibling&&(this.nextElementSibling.style.display=\'flex\')">' +
          '<div class="manga-consultation-reserve__instructor-img manga-consultation-reserve__instructor-img--placeholder" style="display:none"></div>'
        : '<div class="manga-consultation-reserve__instructor-img manga-consultation-reserve__instructor-img--placeholder"></div>';

      // 説明文のHTMLデコード・改行変換
      const descHtml = (instructor.description || '')
        .replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .replace(/\\n/g, '<br>').replace(/\n/g, '<br>');

      // 1行目（最初の<br>まで）を抽出する
      const firstLineEnd = descHtml.indexOf('<br>');
      const firstLine    = firstLineEnd !== -1 ? descHtml.substring(0, firstLineEnd) : descHtml;
      const restLines    = firstLineEnd !== -1 ? descHtml.substring(firstLineEnd)    : '';

      // 料金ラベルを生成する
      const priceLabel = buildPriceLabel(instructor);

      // カードのHTML構築
      item.innerHTML =
        '<div class="manga-consultation-reserve__instructor-header">' +
          '<div class="manga-consultation-reserve__instructor-header-left">' +
            imgHtml +
            '<div class="manga-consultation-reserve__instructor-info">' +
              '<span class="manga-consultation-reserve__instructor-name">' + instructor.name + '</span>' +
              '<span class="manga-consultation-reserve__instructor-price">' + priceLabel + '</span>' +
            '</div>' +
          '</div>' +
          '<span class="manga-consultation-reserve__instructor-radio"></span>' +
        '</div>' +
        '<div class="manga-consultation-reserve__instructor-desc-wrap">' +
          '<div class="manga-consultation-reserve__instructor-first-line">' + firstLine + '</div>' +
          (restLines
            ? '<div class="manga-consultation-reserve__instructor-rest" hidden>' + restLines + '</div>' +
              '<button type="button" class="manga-consultation-reserve__instructor-more">さらに表示</button>'
            : '') +
        '</div>';

      // カード全体クリック → 講師選択（「さらに表示」ボタン以外）
      item.addEventListener('click', function (e) {
        if (e.target.classList.contains('manga-consultation-reserve__instructor-more')) return;
        onSelectInstructor(instructor);
      });

      // 「さらに表示」クリック → 説明の展開・折りたたみ
      const moreBtn = item.querySelector('.manga-consultation-reserve__instructor-more');
      if (moreBtn) {
        moreBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          const rest = item.querySelector('.manga-consultation-reserve__instructor-rest');
          if (rest.hidden) {
            rest.hidden = false;
            moreBtn.textContent = '閉じる';
          } else {
            rest.hidden = true;
            moreBtn.textContent = 'さらに表示';
          }
        });
      }

      instructorBtns.appendChild(item);
    });
  }

  // ── 講師カードに表示する料金ラベルを生成 ──────────────────
  function buildPriceLabel(instructor) {
    const has30 = instructor.price30 != null && instructor.variant30Id;
    const has60 = instructor.price60 != null && instructor.variant60Id;
    if (state.selectedDuration === 30 && has30) {
      return '30分 ¥' + instructor.price30.toLocaleString();
    } else if (state.selectedDuration === 60 && has60) {
      return '60分 ¥' + instructor.price60.toLocaleString();
    } else if (has30) {
      return '30分 ¥' + instructor.price30.toLocaleString();
    } else if (has60) {
      return '60分 ¥' + instructor.price60.toLocaleString();
    }
    return '';
  }

  function bindDurationButtons() {
    const btns = document.querySelectorAll('.manga-consultation-reserve__btn--duration');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.selectedDuration = parseInt(btn.dataset.duration, 10);

        // 枠変更時: 講師選択をリセットしてカレンダーを非表示にする
        state.selectedInstructor = null;
        state.isAny = false;
        resetFromCalendar();

        // 枠に対応した講師リストを再描画する
        buildInstructorButtons();
      });
    });
  }

  function bindCalendarNav() {
    calPrevBtn.addEventListener('click', async function () {
      // 当月より前には戻れない
      if (state.monthOffset <= 0) return;
      state.monthOffset--;
      updateNavButtons();

      if (state.isAny) {
        if (!state.anyInstances || state.anyInstances.length === 0) return;
        state.anyInstances.forEach(function (item) { item.instance.previous('month'); });
        resetFromSlots();
        state.anyAvailabilities = {};
        showLoading(true);
        await fetchAnyAvailabilitiesForCurrentMonth();
        showLoading(false);
        renderCalendarAny();
      } else {
        if (!state.sesamiInstance) return;
        state.sesamiInstance.previous('month');
        resetFromSlots();
        renderCalendar();
      }
    });

    calNextBtn.addEventListener('click', async function () {
      // 翌月より先には進めない
      if (state.monthOffset >= 1) return;
      state.monthOffset++;
      updateNavButtons();

      if (state.isAny) {
        if (!state.anyInstances || state.anyInstances.length === 0) return;
        state.anyInstances.forEach(function (item) { item.instance.next('month'); });
        resetFromSlots();
        state.anyAvailabilities = {};
        showLoading(true);
        await fetchAnyAvailabilitiesForCurrentMonth();
        showLoading(false);
        renderCalendarAny();
      } else {
        if (!state.sesamiInstance) return;
        state.sesamiInstance.next('month');
        resetFromSlots();
        renderCalendar();
      }
    });
  }

  // ── 前月・次月ボタンの有効/無効を更新する ──────────────────
  function updateNavButtons() {
    calPrevBtn.disabled = state.monthOffset <= 0;
    calNextBtn.disabled = state.monthOffset >= 1;
    calPrevBtn.style.opacity = state.monthOffset <= 0 ? '0.3' : '1';
    calNextBtn.style.opacity = state.monthOffset >= 1 ? '0.3' : '1';
  }

  async function fetchAnyAvailabilitiesForCurrentMonth() {
    await Promise.all(state.anyInstances.map(async function (item) {
      const inst  = item.instance;
      const instr = item.instructor;
      if (!inst.data || !inst.data.rows) return;
      const dayChecks = [];
      inst.data.rows.forEach(function (row) {
        row.forEach(function (day) {
          if (day.isPast || !day.isCurrentMonth) return;
          dayChecks.push(
            day.getAvailabilities().then(function (slots) {
              if (!slots || slots.length === 0) return;
              slots.forEach(function (slot) {
                const parts = slot.startTime.split(' ');
                const dk = parts[0]; const tk = parts[1];
                if (!dk || !tk) return;
                if (!state.anyAvailabilities[dk]) state.anyAvailabilities[dk] = {};
                if (!state.anyAvailabilities[dk][tk]) state.anyAvailabilities[dk][tk] = [];
                if (!state.anyAvailabilities[dk][tk].some(function (i) { return i.id === instr.id; }))
                  state.anyAvailabilities[dk][tk].push(instr);
              });
            }).catch(function () {})
          );
        });
      });
      await Promise.all(dayChecks);
    }));
  }

  async function onSelectAny() {
    setActiveInstructorButton('any');
    state.isAny = true;
    state.selectedInstructor = null;
    state.anyInstances = [];
    state.anyAvailabilities = {};
    resetFromCalendar();
    showLoading(true);
    hideError();
    try {
      // 選択中の枠に対応している講師のみを対象にする
      const available = getAvailableInstructors();
      await Promise.all(available.map(async function (instr) {
        const vId  = getVariantId(instr);
        const inst = await createSesamiInstance(instr.productId, vId);
        state.anyInstances.push({ instructor: instr, instance: inst });
        const dayChecks = [];
        if (inst.data && inst.data.rows) {
          inst.data.rows.forEach(function (row) {
            row.forEach(function (day) {
              if (day.isPast || !day.isCurrentMonth) return;
              dayChecks.push(
                day.getAvailabilities().then(function (slots) {
                  if (!slots || slots.length === 0) return;
                  slots.forEach(function (slot) {
                    const parts = slot.startTime.split(' ');
                    const dk = parts[0]; const tk = parts[1];
                    if (!dk || !tk) return;
                    if (!state.anyAvailabilities[dk]) state.anyAvailabilities[dk] = {};
                    if (!state.anyAvailabilities[dk][tk]) state.anyAvailabilities[dk][tk] = [];
                    if (!state.anyAvailabilities[dk][tk].some(function (i) { return i.id === instr.id; }))
                      state.anyAvailabilities[dk][tk].push(instr);
                  });
                }).catch(function () {})
              );
            });
          });
        }
        await Promise.all(dayChecks);
      }));
      state.sesamiInstance = state.anyInstances[0].instance;
      showLoading(false);
      showCalendar();
      renderCalendarAny();
    } catch (e) {
      showError('空き状況の取得に失敗しました。再度お試しください。');
      showLoading(false);
    }
  }

  async function onSelectInstructor(instructor) {
    setActiveInstructorButton(instructor.id);
    state.isAny = false;
    state.selectedInstructor = instructor;
    resetFromCalendar();
    showLoading(true);
    hideError();
    try {
      const variantId = getVariantId(instructor);
      const instance  = await createSesamiInstance(instructor.productId, variantId);
      state.sesamiInstance = instance;
      showLoading(false);
      showCalendar();
      renderCalendar();
    } catch (e) {
      showError('空き状況の取得に失敗しました。しばらくしてから再度お試しください。');
      showLoading(false);
    }
  }

  function renderCalendarAny() {
    const data = state.sesamiInstance && state.sesamiInstance.data;
    if (!data) return;
    calMonthLabel.textContent = getMonthLabel(data);
    calLabels.innerHTML = '';
    const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
    data.labels.forEach(function (dateStr) {
      const li = document.createElement('li');
      li.textContent = dayNames[new Date(dateStr).getDay()];
      calLabels.appendChild(li);
    });
    calDays.innerHTML = '';
    data.rows.forEach(function (row) {
      row.forEach(function (dayObj) {
        const li = document.createElement('li');
        li.textContent = new Date(dayObj.date).getDate();
        if (dayObj.isPast) {
          li.classList.add('is-past');
        } else if (!dayObj.isCurrentMonth) {
          li.classList.add('is-other-month', 'is-past');
        } else {
          const dateKey  = formatDate(new Date(dayObj.date));
          const daySlots = state.anyAvailabilities[dateKey];
          const hasAny   = daySlots && Object.keys(daySlots).length > 0;
          if (hasAny) {
            li.classList.add('is-active', 'is-available');
            li.style.cursor = 'pointer';
            (function (dk, ds) {
              li.addEventListener('click', function () {
                document.querySelectorAll('#cal-days li').forEach(function (el) { el.classList.remove('is-selected'); });
                li.classList.add('is-selected');
                onSelectDayAny(dk, ds);
              });
            })(dateKey, daySlots);
          } else {
            li.classList.add('is-unavailable');
          }
        }
        if (dayObj.isToday) li.classList.add('is-today');
        calDays.appendChild(li);
      });
    });
  }

  function onSelectDayAny(dateKey, daySlots) {
    resetFromSlots();
    const mergedSlots = Object.keys(daySlots).sort().map(function (timeKey) {
      return { startTime: dateKey + ' ' + timeKey, candidates: daySlots[timeKey] };
    });
    if (mergedSlots.length === 0) {
      showSlots();
      slotList.innerHTML = '<p>この日は予約可能な時間帯がありません。</p>';
      return;
    }
    renderSlotsAny(mergedSlots);
  }

  function renderSlotsAny(mergedSlots) {
    showSlots();
    slotList.innerHTML = '';
    mergedSlots.forEach(function (item) {
      const btn = document.createElement('button');
      btn.className = 'manga-consultation-reserve__btn manga-consultation-reserve__btn--slot';
      btn.textContent = item.startTime.split(' ')[1] || item.startTime;
      (function (capturedItem) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.manga-consultation-reserve__btn--slot').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          const candidates = capturedItem.candidates;
          state.selectedInstructor = candidates[Math.floor(Math.random() * candidates.length)];
          state.selectedVariantId  = getVariantId(state.selectedInstructor);
          state.selectedSlot       = { startTime: capturedItem.startTime };
          renderConfirm();
        });
      })(item);
      slotList.appendChild(btn);
    });
  }

  function createSesamiInstance(productId, variantId) {
    return new Promise(function (resolve, reject) {
      function tryCreate() {
        if (typeof SesamiSDK === 'undefined') { setTimeout(tryCreate, 200); return; }
        try {
          const instance = new SesamiSDK({ shopId: shopId, productId: productId, variantId: variantId, quantity: 1, autoLoad: true });
          instance.init();

          // data.rows が取得できるまで待機してから resolve する
          var attempts = 0;
          var maxAttempts = 100; // 最大10秒待機
          function waitForData() {
            if (instance.data && instance.data.rows) {
              resolve(instance);
            } else if (attempts >= maxAttempts) {
              reject(new Error('SesamiSDK data timeout'));
            } else {
              attempts++;
              setTimeout(waitForData, 100);
            }
          }
          waitForData();
        } catch (e) { reject(e); }
      }
      tryCreate();
    });
  }

  function createSesamiInstanceNoAutoLoad(productId, variantId) {
    return new Promise(function (resolve, reject) {
      function tryCreate() {
        if (typeof SesamiSDK === 'undefined') { setTimeout(tryCreate, 200); return; }
        try {
          const instance = new SesamiSDK({ shopId: shopId, productId: productId, variantId: variantId, quantity: 1, autoLoad: false });
          instance.init();
          resolve(instance);
        } catch (e) { reject(e); }
      }
      tryCreate();
    });
  }

  function getVariantId(instructor) {
    if (state.selectedDuration === 30 && instructor.variant30Id) return instructor.variant30Id;
    if (state.selectedDuration === 60 && instructor.variant60Id) return instructor.variant60Id;
    return instructor.variant30Id || instructor.variant60Id || '';
  }

  function getMonthLabel(data) {
    if (!data || !data.rows) return '';
    for (var r = 0; r < data.rows.length; r++) {
      for (var d = 0; d < data.rows[r].length; d++) {
        var day = data.rows[r][d];
        if (day.isCurrentMonth) {
          var dt = new Date(day.date);
          return dt.getFullYear() + '年' + (dt.getMonth() + 1) + '月';
        }
      }
    }
    if (data.labels && data.labels.length > 0) {
      var dt = new Date(data.labels[0]);
      return dt.getFullYear() + '年' + (dt.getMonth() + 1) + '月';
    }
    return '';
  }

  function formatDate(date) {
    const d = new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  function sleep(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }

  async function renderCalendar() {
    const sdk  = state.sesamiInstance;
    const data = sdk && sdk.data;
    if (!data) return;
    calMonthLabel.textContent = getMonthLabel(data);
    calLabels.innerHTML = '';
    const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
    data.labels.forEach(function (dateStr) {
      const li = document.createElement('li');
      li.textContent = dayNames[new Date(dateStr).getDay()];
      calLabels.appendChild(li);
    });
    calDays.innerHTML = '';
    const dayEntries = [];
    data.rows.forEach(function (row) {
      row.forEach(function (day) {
        const li = document.createElement('li');
        li.textContent = new Date(day.date).getDate();
        if (day.isPast) {
          li.classList.add('is-past');
        } else if (!day.isCurrentMonth) {
          li.classList.add('is-other-month', 'is-past');
        } else {
          li.classList.add('is-loading-availability');
          dayEntries.push({ li: li, day: day });
        }
        if (day.isToday) li.classList.add('is-today');
        calDays.appendChild(li);
      });
    });
    await Promise.all(dayEntries.map(async function (entry) {
      const li = entry.li; const day = entry.day;
      try {
        const slots = await day.getAvailabilities();
        li.classList.remove('is-loading-availability');
        if (slots && slots.length > 0) {
          li.classList.add('is-active', 'is-available');
          li.style.cursor = 'pointer';
          li.addEventListener('click', function () {
            document.querySelectorAll('#cal-days li').forEach(function (el) { el.classList.remove('is-selected'); });
            li.classList.add('is-selected');
            onSelectDay(day);
          });
        } else {
          li.classList.add('is-unavailable');
        }
      } catch (e) {
        li.classList.remove('is-loading-availability');
        li.classList.add('is-unavailable');
      }
    }));
  }

  async function onSelectDay(day) {
    state.selectedDay = day; state.selectedSlot = null;
    resetFromSlots(); showLoading(true);
    try {
      const slots = await day.getAvailabilities();
      showLoading(false);
      if (!slots || slots.length === 0) {
        showSlots();
        slotList.innerHTML = '<p>この日は予約可能な時間帯がありません。</p>';
        return;
      }
      renderSlots(slots);
    } catch (e) {
      showLoading(false);
      showError('時刻の取得に失敗しました。再度お試しください。');
    }
  }

  function renderSlots(slots) {
    showSlots(); slotList.innerHTML = '';
    slots.forEach(function (slot) {
      const btn = document.createElement('button');
      btn.className = 'manga-consultation-reserve__btn manga-consultation-reserve__btn--slot';
      btn.textContent = slot.startTime.split(' ')[1] || slot.startTime;
      btn.addEventListener('click', function () {
        document.querySelectorAll('.manga-consultation-reserve__btn--slot').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        onSelectSlot(slot);
      });
      slotList.appendChild(btn);
    });
  }

  function onSelectSlot(slot) {
    state.selectedSlot = slot;
    state.selectedVariantId = getVariantId(state.selectedInstructor);
    renderConfirm();
  }

  function renderConfirm() {
    showConfirm();
    const instructor = state.selectedInstructor;
    let price = null;
    if (state.selectedDuration === 30 && instructor.price30 != null) {
      price = instructor.price30;
    } else if (state.selectedDuration === 60 && instructor.price60 != null) {
      price = instructor.price60;
    } else {
      price = instructor.price30 != null ? instructor.price30 : instructor.price60;
    }
    const priceStr = price != null ? '¥' + price.toLocaleString() : '要確認';
    const timeParts = state.selectedSlot.startTime.split(' ');
    bookingSummary.innerHTML =
      '<dt>講師</dt><dd>' + instructor.name + (state.isAny ? '（自動割り当て）' : '（指名）') + '</dd>' +
      '<dt>レッスン時間</dt><dd>' + state.selectedDuration + '分</dd>' +
      '<dt>日付</dt><dd>' + timeParts[0] + '</dd>' +
      '<dt>開始時刻</dt><dd>' + timeParts[1] + '</dd>' +
      '<dt>料金</dt><dd>' + priceStr + '</dd>';
  }

  async function handleAddToCart() {
    if (!state.selectedVariantId || !state.selectedSlot) {
      showError('予約内容が正しく選択されていません。');
      return;
    }
    var termsChecked = document.getElementById('chk-terms');
    var errTerms     = document.getElementById('err-terms');
    if (termsChecked && !termsChecked.checked) {
      errTerms.hidden = false;
      termsChecked.closest('.manga-consultation-reserve__question').scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (errTerms) errTerms.hidden = true;

    // ── カートにマンガ個別相談の商品が既に入っていないか確認 ──────────
    try {
      var cartRes  = await fetch('/cart.js');
      var cartData = await cartRes.json();
      var productIds = instructors.map(function (instr) { return String(instr.productId); });
      var alreadyIn  = cartData.items.some(function (item) {
        return productIds.indexOf(String(item.product_id)) !== -1;
      });
      if (alreadyIn) {
        showError('既にマンガ個別相談の予約がカートに入っています。マンガ個別相談の予約は1件ずつご対応をお願いいたします。');
        return;
      }
    } catch (e) {
      showError('カートに追加できませんでした。お手数ですが再度カートに入れ直してください。');
      return;
    }

    addToCartBtn.disabled    = true;
    addToCartBtn.textContent = '処理中...';

    var reservationToken = null;
    try {
      var reserveInstance = state.sesamiInstance;
      if (state.isAny && state.selectedInstructor) {
        var assignedItem = state.anyInstances.find(function (item) {
          return item.instructor.id === state.selectedInstructor.id;
        });
        if (assignedItem) reserveInstance = assignedItem.instance;
      }
      var reserveSlot = state.selectedSlot;
      if (state.isAny && reserveInstance && reserveInstance.data) {
        var targetStartTime = state.selectedSlot.startTime;
        var targetDate = targetStartTime.split(' ')[0];
        outer: for (var ri = 0; ri < reserveInstance.data.rows.length; ri++) {
          for (var di = 0; di < reserveInstance.data.rows[ri].length; di++) {
            var dayObj = reserveInstance.data.rows[ri][di];
            if (formatDate(new Date(dayObj.date)) === targetDate) {
              try {
                var daySlots = await dayObj.getAvailabilities();
                var matched  = (daySlots || []).find(function (s) { return s.startTime === targetStartTime; });
                if (matched) { reserveSlot = matched; break outer; }
              } catch (e) {}
            }
          }
        }
      }

      var reservation = await reserveInstance.reserve(reserveSlot);
      if (reservation && reservation.token) reservationToken = reservation.token;
    } catch (e) {
      showError('スロットの確保に失敗しました。再度お試しください。');
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'カートに追加してチェックアウトへ';
      return;
    }
    if (!reservationToken) {
      showError('予約トークンの取得に失敗しました。再度お試しください。');
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'カートに追加してチェックアウトへ';
      return;
    }

    var startTimeParts = (state.selectedSlot.startTime || '').split(' ');
    var dateStr = startTimeParts[0] || '';
    var timeStr = startTimeParts[1] || '';
    var resourceId = null;
    try {
      resourceId = (state.selectedSlot.teamMember && state.selectedSlot.teamMember.id) ||
                   (state.sesamiInstance.teamMember && state.sesamiInstance.teamMember.id) || null;
    } catch (e) { resourceId = null; }

    // デバッグ: カート追加前の状態を確認する

    var instructorName = state.selectedInstructor
      ? state.selectedInstructor.name + (state.isAny ? '（自動割り当て）' : '（指名）') : '';

    var cartProperties = {
      '_locale': 'ja', '_reservation_token': reservationToken,
      'Date': dateStr, 'Time': timeStr, 'Timezone': 'Asia/Tokyo',
      '担当講師': instructorName,
      'マイクの設定・接続の事前確認': '確認済み',
    };
    if (resourceId && !state.isAny) cartProperties['Resources'] = resourceId;

    try {
      var cartResponse = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(state.selectedVariantId), quantity: 1, properties: cartProperties })
      });
      if (!cartResponse.ok) {
        var cartErr = await cartResponse.json().catch(function () { return {}; });
        showError('Shopifyカートへの追加に失敗しました。variantIDを確認してください。(HTTP ' + cartResponse.status + ')');
        addToCartBtn.disabled = false; addToCartBtn.textContent = 'カートに追加してチェックアウトへ';
        return;
      }
      window.location.href = '/checkout';
    } catch (e) {
      showError('カート処理中にエラーが発生しました。');
      addToCartBtn.disabled = false; addToCartBtn.textContent = 'カートに追加してチェックアウトへ';
    }
  }

  function setActiveInstructorButton(instructorId) {
    document.querySelectorAll('.manga-consultation-reserve__instructor-item').forEach(function (item) {
      item.classList.toggle('is-active', item.dataset.instructorId === instructorId);
    });
    const anyBtn = instructorBtns.querySelector('[data-instructor-id="any"]');
    if (anyBtn) anyBtn.classList.toggle('is-active', instructorId === 'any');
  }

  function getStickyHeaderHeight() {
    var header = document.querySelector('header');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return header.getBoundingClientRect().height;
  }

  // 講師を選んだあと、カレンダーがどこに出たのか分からなくなるので、そこまで送る。
  // window.scrollTo の smooth は黙って効かない環境があるため、自前で動かす
  function scrollToStep(el) {
    if (!el) return;
    var target = el.getBoundingClientRect().top + window.pageYOffset - getStickyHeaderHeight() - 16;
    if (target < 0) target = 0;

    var start = window.pageYOffset;
    var distance = target - start;
    if (Math.abs(distance) < 2) return;
    if (!window.requestAnimationFrame) { window.scrollTo(0, target); return; }

    // 距離が長くても間延びしないよう、300〜700ms に収める
    var duration = Math.min(700, Math.max(300, Math.abs(distance)));
    var startTime = null;
    var cancelled = false;

    function cancel() { cancelled = true; }
    function unbind() {
      window.removeEventListener('wheel', cancel);
      window.removeEventListener('touchstart', cancel);
      window.removeEventListener('keydown', cancel);
    }
    // 途中で自分で動かしはじめたら、じゃまをしない
    window.addEventListener('wheel', cancel, { passive: true });
    window.addEventListener('touchstart', cancel, { passive: true });
    window.addEventListener('keydown', cancel);

    function step(now) {
      if (cancelled) { unbind(); return; }
      if (startTime === null) startTime = now;
      var p = (now - startTime) / duration;
      if (p > 1) p = 1;
      // ease-in-out
      var eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, start + distance * eased);
      if (p < 1) { window.requestAnimationFrame(step); } else { unbind(); }
    }
    window.requestAnimationFrame(step);
  }

  // 中身が描かれたあとに位置を測りたいので1フレーム待つ
  function scrollToStepSoon(el) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () { scrollToStep(el); });
    } else {
      scrollToStep(el);
    }
  }

  function showCalendar() {
    stepCalendar.hidden = false;
    updateNavButtons();
    scrollToStepSoon(stepCalendar);
  }

  // 日付を選んだあとも、時刻の並びが画面の外に出ることがある
  function showSlots() {
    var wasHidden = stepSlots.hidden;
    stepSlots.hidden = false;
    if (wasHidden) scrollToStepSoon(stepSlots);
  }

  // 時刻を選んだあとの確認欄も、出た場所まで送る
  function showConfirm() {
    var wasHidden = stepConfirm.hidden;
    stepConfirm.hidden = false;
    if (wasHidden) scrollToStepSoon(stepConfirm);
  }
  function showLoading(visible) { loadingEl.hidden = !visible; }
  function showError(msg)       { errorMsgEl.textContent = msg; errorEl.hidden = false; }
  function hideError()          { errorEl.hidden = true; }

  function resetFromCalendar() {
    stepCalendar.hidden = true; resetFromSlots();
    state.sesamiInstance = null; state.anyInstances = [];
    state.anyAvailabilities = {}; state.selectedDay = null;
    state.monthOffset = 0;
    updateNavButtons();
  }
  function resetFromSlots() {
    stepSlots.hidden = true; stepConfirm.hidden = true;
    slotList.innerHTML = ''; state.selectedSlot = null; state.selectedVariantId = null;
  }

  if (root) init();
})();